// Keys here should be the same as in Bravestorm's AccountPermissionType enum
export enum AccountPermissionType {
  AgentList,
  LogOffPeer,
  AssignmentHistory
}

export namespace AccountPermissionType {
  function isIndex(key): boolean {
    const n = Math.floor(Number(key));
    return String(n) === key && n >= 0;
  }

  const _names: string[] = Object
    .keys(AccountPermissionType)
    .filter(key => !isIndex(key));

  const _indices: number[] = Object
    .keys(AccountPermissionType)
    .filter(key => isIndex(key))
    .map(index => Number(index));

  export function names(): string[] {
    return _names;
  }

  export function indices(): number[] {
    return _indices;
  }
}
